<template>
  <t-report-generate
      v-model="form"
      modal
      sub-validation-tag="sub-checklist-report-photos-enterprise"
      default-word
      enable-generate-word
      enable-generate-pdf
      enable-setting
      enable-report-by-part
      :add-error-word="onWordDisabledDetail3Photos"
      origin="Teste de Origem"
      help="Somente serão consideradas inspeções e ambientes finalizados. Para configurar as informações do cabeçalho utilize o cadastro de empresas."
      button-title="Relatório"
      :relation-key="form.enterpriseId"
      java-report
      title="Memorial Fotográfico por Empreendimento">

    <template #default="{status}">

      <t-input-code-label :command="'insert'" :status="status" required enterprise
                          v-model="form.enterpriseId"/>


      <t-input select :options="typeChecklistOptions"
               v-model="form.typeChecklistId"
               @change="getResumeTypeChecklistModel"
               first-default
               placeholder="Todas"
               label="Modelo de Inspeção"/>


        <t-input-search required select v-model="form.reportLayout"
                        :options="ReportEvidenceLayoutType.list"
                        label="Layout"/>


        <t-input label="Iniciar númeração"
                 help="Utilize por exemplo 6, quando exibir no seu relatório principal outras 5 imagens já existentes"
                 :disabled="!form.subtitleSequenceEnable"
                 v-model="form.subtitleSequenceStart"/>




      <div class="divider"></div>

      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideEnvironment" switch>
        Ocultar Título com o nome do ambiente
      </b-form-checkbox>
<!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideSpotFolderDivision" switch>
        Ocultar Divisão e Pavimento?
      </b-form-checkbox>-->



      <div class="divider"></div>
      <t-input radio required stacked v-model="form.subtitleFormat"
               :options="ReportSubtitleType.list" label="Formato das legendas das fotos"/>

      <t-msg warning>
        <b>Dica</b> <br/>Use a Macro abaixo para melhorar a formatação antes de colar no seu documento final.<br/>
        <ul>
          <li><a href="https://www.loom.com/share/f9c4833c71f14be3819ca6b5109ce698" target="_blank">Video com Orientações</a></li>
          <li> <a @click="showMacro = !showMacro">Código com Macro para Word</a></li>
        </ul>

        <t-button v-show="showMacro" class="mr-2" small  @click="copyToClipboard(macro,'macroVBA')">
          <b-icon-clipboard class="mr-2"></b-icon-clipboard>
          Copiar Macro
        </t-button>

        <t-button v-show="showMacro" small  @click="ui.downloadTxt(macro,'macro-vba.txt')">
          <b-icon-download class="mr-2"></b-icon-download>
          Download Macro
        </t-button>
      </t-msg>

      <t-msg info v-if="onWordDisabledDetail3Photos !== ''">
        {{onWordDisabledDetail3Photos}}
      </t-msg>

      <!--
            <t-input-search v-model="form.issueDate" placeholder="Todas" date enable-range
                            label="Período Inspeções"/>-->


    </template>

    <template #setting>

      <t-msg info v-if="objValid(typeChecklistModel.typeChecklistNumber)">Altere as configurações padrões acessando
        Inspeções > Configurações >
        <b-link :to="{path:'/checklist/type-model/'+typeChecklistModel.typeChecklistNumber}" target="_blank">Modelo da
          Inspeção
          Relacionado
        </b-link>
      </t-msg>


      <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportHideHeaderFooter" switch>
              Ocultar todas informações do cabeçalho e rodapé?
            </b-form-checkbox>-->


      <!--      <b-form-checkbox class="mt-2 mb-2" v-show="!form.reportHideSpotFolderDivision" v-model="form.reportBreakPageBySpotFolder" switch>
              Habilitar quebra de página por pavimento?
            </b-form-checkbox>-->


      <!--      <t-input-search required radio v-show="!form.reportHideHeaderFooter" v-model="form.reportHeaderPositionLogo"
                            :options="ReportPositionLogoHeaderType.list" label="Cabeçalho logomarca"/>-->


      <!--      <b-form-checkbox class="mt-2 mb-2" v-model="form.reportShowCover" switch>
              Exibir a capa?
            </b-form-checkbox>-->



    </template>

  </t-report-generate>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageReportItemMixin from "@/mixins/page/pageReportItemMixin"
import WorkService from "@/services/modules/place/Work.service";
import ReportEvidenceLayoutType from "@/model/types/modules/checklist/ReportEvidenceLayoutType";
import ReportPositionLogoHeaderType from "@/model/types/modules/checklist/ReportPositionLogoHeaderType";
import ReportSubtitleType from "@/model/types/modules/checklist/ReportSubtitleType";
import TypeChecklistModelService from "@/services/modules/checklist/TypeChecklistModel.service";
import macroVbaReportEvidence from "@/views/modules/checklist/Report/docs/macro-vba-report-evidence";
import ui from "@/assets/scripts/ui";


export default {

  mixins: [pageDefaultMixin, pageReportItemMixin],
  name: 'ReportPhotoEnterpriseEvidence',
  data() {
    return {
      ui,
      ReportEvidenceLayoutType,
      ReportPositionLogoHeaderType,
      ReportSubtitleType,
      path: "checklist/report", //Path padrão para validação, porém página foi configurada para validação direta na mesma página (validationOtherPageId)
      form: {
        workId: 0,
        enterpriseId: this.enterpriseId,
        typeChecklistId: this.typeChecklistId,
        enableAllEnterprises: true,
        titleReport: "Relatório Fotográfico",
        subtitleReport: "",
        workSequence: "",
        issueDate: "",
        reportHideHeaderFooter: true,
        reportHideSpotFolderDivision: true,
        reportBreakPageBySpotFolder: false,
        reportLayout: ReportEvidenceLayoutType.type.BASIC_4_PHOTOS_PORTRAIT,
        reportHeaderPositionLogo: ReportPositionLogoHeaderType.type.LEFT,
        subtitleFormat: ReportSubtitleType.type.BASIC,
        subtitleSequenceEnable: true,
        subtitleSequenceStart: 1,
        reportShowCover: false, /*FIXO POR CONTEXTO*/
      },

      typeChecklistModel: {},
      workOptions: [],
      typeChecklistOptions: [],
      showMacro: false,
      macro:macroVbaReportEvidence,
    }
  },
  props: {
    enterpriseId: Number,
    typeChecklistId: Number,
  },
  methods: {

    mountedPrepare() {


    },
    async mountedContinued() {

      if (this.enterpriseId > 0) {
        this.getResumeTypeChecklistModel()
      }


      await WorkService.selectList().then((list) => {
        this.workOptions = list
      }).catch(error => this.responseError(error))

      await TypeChecklistModelService.selectList().then((list) => {
        this.typeChecklistOptions = list
      }).catch(error => this.responseError(error))

    },

    setSubtitleByWork() {

      setTimeout(() => {

        if (this.form.workId > 0) {
          this.form.subtitleReport = this.workOptions.find(a => a.value === this.form.workId).text
        }

      }, 100)

    },

    async getResumeTypeChecklistModel() {

      setTimeout(async () => {

        if (this.form.typeChecklistId > 0) {
          await TypeChecklistModelService.getResume("id", this.form.typeChecklistId).then(resume => {

            this.typeChecklistModel = resume

            this.form.titleReport = resume.reportEvidenceDefaultTitle
            this.form.subtitleReport = resume.reportEvidenceDefaultSubtitle

            /*IDEM EM WORK EVIDENCE E CHECKLIST EVIDENCE*/
            this.form.reportLayout = resume.reportEvidenceDefaultLayout
            this.form.reportHeaderPositionLogo = resume.reportEvidenceDefaultHeaderPositionLogo
            this.form.reportHideHeaderFooter = resume.reportEvidenceDefaultHideHeaderFooter
            this.form.reportHideSpotFolderDivision = resume.reportEvidenceDefaultHideSpotFolderDivision
            this.form.reportHideEnvironment = resume.reportEvidenceDefaultHideEnvironment
            this.form.reportBreakPageBySpotFolder = resume.reportEvidenceBreakPageBySpotFolder
            this.form.reportShowCover = resume.reportEvidenceShowCover
            this.form.environmentSort = resume.reportEvidenceDefaultEnvironmentSort
            this.form.subtitleFormat = resume.reportEvidenceDefaultSubtitleFormat
            /*---*/

          })
        }

      }, 100)

    }

  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedContinued()

  },
  computed: {

    onWordDisabledDetail3Photos(){
      if(this.form.reportLayout === this.ReportEvidenceLayoutType.type.DETAIL_3_PHOTOS){
        return 'A geração do relatório em formato Word para este layout 3 fotos detalhada está desabilitada, por favor para este formato utilize PDF.'
      }else{
        return ''
      }

    }

  },

}
</script>
